import axios from 'axios';
import { generateQueryParams } from 'utils/generateQueryParams';

export const TribesService = {
  async getTribes(page = 1, perPage = 10) {
    const params = generateQueryParams({
      page,
      size: perPage,
    });

    const res = await axios.get('rbac/v1/tribes/', { params });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
  async createTribes(data) {
    const res = await axios.post('rbac/v1/tribes/', data);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
  async editTribes(data, id) {
    const res = await axios.put(`rbac/v1/tribes/${id}/`, data);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
  async regenerateTokenWithTribe(payload) {
    const res = await axios.post(`token/generate_with_tribe/`, payload);
    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
};
